var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"admin-reseller-admin mt-page"},[_c('crud-table',{attrs:{"title":_vm.$i18n.gt('LABEL_MANAGE_RESELLER_ADMINS'),"item-table":"reseller-admin","item-name":"Admin","new-item":_vm.newItem,"filters":_vm.filters,"display-fields":_vm.displayFields,"edit-fields":_vm.editFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }